angular.module('mean.contacts').controller('RequestContactCountController', ['$scope', 'Global', 'Contacts', 'MeanUser', 'Requests', '$rootScope',
  function($scope, Global, Contacts, MeanUser, Requests, $rootScope) {
    var vm = this;

    function RequestContactCountController() {
        vm.user = MeanUser.user;
        vm.total_new_requests = 0;

        Requests.query({'requestee': vm.user._id}, function(requests) {
            vm.total_new_requests = requests.length;
        });
    }

    RequestContactCountController();

    RequestContactCountController.prototype.getContactCount = function() {
        vm.total_new_requests = 0;
        //first check to see if i have any requests waiting
        Requests.query({'requestee': vm.user._id}, function(requests) {
            vm.total_new_requests = requests.length;
        });
    };

    $rootScope.$on('loggedin', function() {
        RequestContactCountController();
    });

    $rootScope.$on('logout', function() {
        vm.total_new_requests = 0;
    });

    $rootScope.$on('update-contact-list', function handler() {
        vm.total_new_requests = vm.total_new_requests - 1;
    });

    $rootScope.$on('update-request-list', function handler() {
        RequestContactCountController();
    });
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contacts/public/controllers/requestContactCountController.js